import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Config } from '@/config';
import {
  errorModalTextRecoil,
  completeModalRecoil,
  modifyModalRecoil,
  passwordModifyModalRecoil,
} from '@/atom/ModalAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import ModalType1 from '@/modal/ModalType1';
import { UserApi } from '@/sdk/UserApi';
import { UpdateUserPasswordDtoTx } from '@/sdk/data-contracts';
import { siteModifyRecoil } from '@/atom/SiteAtom';

const PasswordModifyModal = () => {
  const userApi = new UserApi({ baseURL: Config.API_URL });
  const navigate = useNavigate();

  const setErrorModalText = useSetRecoilState(errorModalTextRecoil);
  const setCompleteModalState = useSetRecoilState(completeModalRecoil);
  const setPasswordModifyModalState = useSetRecoilState(
    passwordModifyModalRecoil,
  );

  const [currentPassword, setCurrentPassword] = useState<string>('');
  const [newPassword, setNewPassword] = useState<string>('');
  const [newPasswordCheck, setNewPasswordCheck] = useState<string>('');

  const handleSubmit = async () => {
    if (
      currentPassword.trim() === '' ||
      newPassword.trim() === '' ||
      newPasswordCheck.trim() === ''
    ) {
      setErrorModalText('빈 칸을 확인해 주세요.');
      return;
    }

    if (newPassword !== newPasswordCheck) {
      setErrorModalText('새로운 비밀번호가 일치하지 않습니다.');
      return;
    }

    const dto: UpdateUserPasswordDtoTx = {
      currentPassword,
      newPassword,
      newPasswordCheck,
    };

    try {
      await userApi.userControllerUpdateUserPassword(dto, {
        headers: {
          Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
          'Content-Type': 'application/json',
        },
      });
      setCompleteModalState(true);
    } catch (err: any) {
      setErrorModalText('현재 비밀번호가 일치하지 않습니다.');
    }
  };

  return (
    <>
      <ModalType1 width={500}>
        <div className="title-box flex aic jcsb">
          <h1>비밀번호 변경</h1>
          <button
            className="x-btn img-box"
            onClick={() => setPasswordModifyModalState(false)}
          >
            <img src="/img/ico_x_444.svg" alt="" />
          </button>
        </div>
        <div className="cnt-area flex fdc">
          <div className="cnt-wrap flex fdc">
            <div className="cnt-box flex fdc">
              <div className="cnt-title-box flex jcsb aie">
                <div className="left-box">
                  <h2 className="tm">기본 정보</h2>
                </div>
                <div className="right-box flex">
                  <h3>
                    <span className="inblock">*</span>필수 항목
                  </h3>
                </div>
              </div>
              <CS.TableType2>
                <table>
                  <tbody>
                    <tr>
                      <th>
                        현재 비밀번호<span className="star-point">*</span>
                      </th>
                      <td colSpan={3}>
                        <IS.TextInputType1
                          style={{ width: 190 }}
                          type="password"
                          value={currentPassword}
                          onChange={(e) => {
                            setCurrentPassword(e.target.value);
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        새로운 비밀번호<span className="star-point">*</span>
                      </th>
                      <td colSpan={3}>
                        <IS.TextInputType1
                          style={{ width: 190 }}
                          type="password"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        새로운 비밀번호 확인
                        <span className="star-point">*</span>
                      </th>
                      <td colSpan={3}>
                        <IS.TextInputType1
                          style={{ width: 190 }}
                          type="password"
                          value={newPasswordCheck}
                          onChange={(e) => setNewPasswordCheck(e.target.value)}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CS.TableType2>
            </div>
          </div>
          <div className="btn-wrap">
            <BS.Btn2Type3
              type="button"
              onClick={() => setPasswordModifyModalState(false)}
            >
              취소
            </BS.Btn2Type3>
            <BS.Btn2Type4 type="button" onClick={handleSubmit}>
              수정
            </BS.Btn2Type4>
          </div>
        </div>
      </ModalType1>
    </>
  );
};

export default PasswordModifyModal;
